import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  timeout: 5000, // 请求超时时间
  withCredentials: true, // 允许携带cookie
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 验证码接口不需要token
    if (!config.url.includes('/captcha')) {
      const token = getToken()
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    }
    // 添加时间戳，防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }
    
    // 添加调试信息
    console.log('Request Config:', {
      url: config.url,
      method: config.method,
      headers: config.headers,
      params: config.params,
      data: config.data
    })
    
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 添加更详细的调试信息
    console.group('API Response');
    console.log('URL:', response.config.url);
    console.log('Method:', response.config.method);
    console.log('Status:', response.status);
    console.log('Data:', response.data);
    console.groupEnd();

    // 如果是验证码接口，直接返回响应
    if (response.config.url.includes('/captcha')) {
      // 将响应类型设置为blob
      if (response.config.responseType === 'blob') {
        return response;
      }
      // 处理SVG验证码
      return {
        code: 200,
        data: 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(response.data)))
      }
    }
    
    const res = response.data
    if (res.code !== 200 && res.code !== 0) {
      console.error('API Error:', {
        url: response.config.url,
        method: response.config.method,
        code: res.code,
        message: res.msg || res.message
      });
      
      Message({
        message: res.msg || res.message || '错误',
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未登录或token过期
      if (res.code === 401) {
        const isLoginApi = (response.config.url || '').includes('/api/admin/auth/login')
        const isLoginPage = router.currentRoute.path === '/login'
        // 登录接口的401属于业务错误，不应再触发登录跳转，避免redirect叠加
        if (!isLoginApi && !isLoginPage) {
          store.dispatch('user/resetToken').then(() => {
            router.push(`/login?redirect=${encodeURIComponent(router.currentRoute.fullPath)}`)
          })
        }
      }
      return Promise.reject(new Error(res.msg || res.message || '错误'))
    } else {
      return res
    }
  },
  error => {
    // 添加更详细的错误调试信息
    console.group('API Error');
    console.error('Request Failed:', error.message);
    
    if (error.config) {
      console.log('Request URL:', error.config.url);
      console.log('Request Method:', error.config.method);
      console.log('Request Data:', error.config.data);
    }
    
    if (error.response) {
      console.log('Response Status:', error.response.status);
      console.log('Response Data:', error.response.data);
    }
    console.groupEnd();

    if (error.response) {
      switch (error.response.status) {
        case 401: {
          const requestUrl = (error.config && error.config.url) || ''
          const isLoginApi = requestUrl.includes('/api/admin/auth/login')
          const isLoginPage = router.currentRoute.path === '/login'
          // 登录页请求登录接口失败时，保持在当前页，仅显示错误提示
          if (!isLoginApi && !isLoginPage) {
            store.dispatch('user/resetToken').then(() => {
              router.push(`/login?redirect=${encodeURIComponent(router.currentRoute.fullPath)}`)
            })
          }
          break
        }
        case 403:
          Message({
            message: error.response.data?.msg || '没有权限访问该资源',
            type: 'error',
            duration: 5 * 1000
          })
          break
        default:
          Message({
            message: error.response.data?.msg || error.response.data?.message || '请求失败',
            type: 'error',
            duration: 5 * 1000
          })
      }
    } else {
      Message({
        message: '网络错误，请检查您的网络连接',
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service 